import router from "@/router";
import axios from "axios";
import Cookies from "js-cookie";
import sleep from "@/utils/sleep.js";
import moment from "moment";

export default {
  async GET_FAVORITES_TOP_BRANDS({ commit }, { idUser }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/top-brands/favorites/${idUser}`,
        params: {
          page: 1,
          rows: 999,
          relations: JSON.stringify([
            {
              table: "a535752a-00a0-41f2-a3c5-3efd4c7d5a68_table",
              key: "brand_id",
            },
          ]),
          where: JSON.stringify([
            { column: "user_id", operator: "=", value: idUser },
          ]),
        },
      });
      commit("SET_FAVORITES_TOP_BRANDS", data.top_brands);
      return { success: true, data: data.top_brands };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_FAVORITES_TIKTOKS({ commit }, { idUser }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/tiktoks/favorites/${idUser}`,
      });
      commit("SET_FAVORITES_TIKTOKS", data.tiktoks);
      return { success: true, data: data.tiktoks };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_FAVORITES_ADS({ state, commit }, { idUser }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/favorites/${idUser}`,
        headers: {
          Authorization: state.token,
        },
        params: {
          page: 1,
          size: 999,
        },
      });
      commit("SET_FAVORITES_ADS", data.data.results);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_PREMIUM_ADS({ state, commit }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/advertisements/collection/title/Blur`,
        headers: {
          Authorization: state.token,
        },
      });
      commit("SET_PREMIUM_ADS", data.data);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_CASES_STUDY({ commit, state }) {
    try {
      let params = {
        skip: state.pageCases * 16,
        take: 16,
        user_id: state.user.id,
      };
      const data = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/case-studies`,
        params,
      });
      commit("SET_CASES_STUDY", data.data.data);
      commit("SET_TOTAL_CASES", data.data.total);
      return { success: true, data: [] };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_DIRECTORY({ commit }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/directory`,
      });
      commit("SET_DIRECTORY", data.directory);
      return { success: true, data: data.directory };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_TIKTOKS({ commit, state }, { addedFilters, idUser }) {
    try {
      let filters = {};
      if (addedFilters) filters = { ...addedFilters };
      if (state.filters) {
        Object.keys(state.filters).forEach((key) => {
          if (state.filters[key]) {
            filters[key] = state.filters[key];
          }
        });
      }
      if (filters['platform']) {
        if (filters['platform'] == 'facebook') {
          commit("SET_TIKTOKS", null);
          return { success: true, data: [] };
        }
      }
      if (filters['format']) {
        if (filters['format'] == 'static image') {
          commit("SET_TIKTOKS", null);
          return { success: true, data: [] };
        }
      }
      let take = state.adsPerPage / 2;
      let skip = (state.page - 1) * take;
      if (!(state.totalAdvertisements == 0 && state.totalTiktoks == 0)) {
        if (skip >= state.totalAdvertisements) {
          skip = skip * 2 - state.totalAdvertisements;
          take *= 2;
        } else if (state.totalAdvertisements - skip < take) {
          take = take + take - state.totalAdvertisements + skip;
        }
      }

      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/tiktoks`,
        data: {
          user_id: idUser,
          skip,
          take,
          orderBy: {
            created_time: "desc",
          },
          month: state.filters_tiktoks.month,
          ...filters,
        },
      });
      commit("SET_TIKTOKS", data);
      return { success: true, data: data.tiktoks };
    } catch (error) {
      console.log(error);
      return { success: false, data: error.response };
    }
  },
  async GET_TOP_BRANDS({ commit, state }) {
    try {
      let filters = [];
      if (state.filters) {
        Object.keys(state.filters_topBrands).forEach((key) => {
          if (state.filters_topBrands[key]) {
            filters[key] = state.filters_topBrands[key];
          }
        });
      }

      let params = {
        page: state.pageTopBrands,
        rows: state.adsPerPage,
        user_id: state.user.id,
        ...filters,
      };

      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/top-brands`,
        params,
      });
      commit("SET_TOP_BRANDS", data);
      commit("SET_TOTAL_TOP_BRANDS", data.total);
      return { success: true, data: data.top_brands };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async ADD_FAVORITE_BRAND({ commit }, { user_id, brand }) {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/top-brands/favorites`,
        data: {
          user_id: user_id,
          topbrand_id: brand.id,
        },
      });
      commit("ADD_BRAND_TO_FAVORITES", {
        value: brand,
        favorite_id: data.top_brand.id,
      });
      return { success: true, data: data };
    } catch (error) {
      console.log(error.response.data);
      return { success: false, data: error.response.data };
    }
  },
  async REMOVE_FAVORITE_BRAND({ commit }, { user_id, brand }) {
    try {
      const { data } = await axios({
        method: "DELETE",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/top-brands/favorites`,
        data: {
          user_id: user_id,
          topbrand_id: brand.id,
        },
      });
      commit("REMOVE_BRAND_TO_FAVORITES", brand.id);
      return { success: true, data: data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
  async ADD_FAVORITE_TIKTOK({ commit }, { user_id, tiktok }) {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/tiktoks/favorites`,
        data: {
          user_id: user_id,
          tiktok_id: tiktok.id,
        },
      });
      commit("ADD_TIKTOK_TO_FAVORITES", {
        value: tiktok,
        favorite_id: data.tiktok.id,
      });
      return { success: true, data: data };
    } catch (error) {
      console.log(error.response.data);
      return { success: false, data: error.response.data };
    }
  },
  async REMOVE_FAVORITE_TIKTOK({ commit }, { user_id, tiktok }) {
    try {
      const { data } = await axios({
        method: "DELETE",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/tiktoks/favorites`,
        data: {
          user_id: user_id,
          tiktok_id: tiktok.id,
        },
      });
      commit("REMOVE_TIKTOK_TO_FAVORITES", tiktok.id);
      return { success: true, data: data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
  async GET_TITLES_SUBTITLES({ state, commit }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/titles-subtitles`,
        headers: {
          Authorization: state.token,
        },
      });
      let fb_ig = data.data.results.find(
        (element) => element.section == "FB and IG"
      );
      commit("SET_FB_IG_TITLES_SUBTITLES", fb_ig);

      let discover = data.data.results.find(
        (element) => element.section == "Discover"
      );
      commit("SET_DISCOVER_SUBTITLES", discover);

      let home = data.data.results.find((element) => element.section == "Home");
      commit("SET_HOME_TITLES_SUBTITLES", home);

      let tiktok = data.data.results.find(
        (element) => element.section == "Tiktok"
      );
      commit("SET_TIKTOK_TITLES_SUBTITLES", tiktok);

      let top_brand = data.data.results.find(
        (element) => element.section == "Top Brand"
      );
      commit("SET_TOP_BRANDS_TITLES_SUBTITLES", top_brand);

      let hooks = data.data.results.find(
        (element) => element.section == "Hooks"
      );
      commit("SET_HOOKS_TITLES_SUBTITLES", hooks);

      let calendar = data.data.results.find(
        (element) => element.section == "Calendar"
      );
      commit("SET_CALENDAR_TITLES_SUBTITLES", calendar);

      let ads_tools = data.data.results.find(
        (element) => element.section == "Ads to test first"
      );

      commit("SET_ADS_TEST_FIRST_TITLES_SUBTITLES", ads_tools);

      let psychology = data.data.results.find(
        (element) => element.section == "Psychology"
      );
      commit("SET_PSYCOLOGY_TITLES_SUBTITLES", psychology);

      let case_study = data.data.results.find(
        (element) => element.section == "Case Studies"
      );
      commit("SET_CASE_STUDIES_TITLES_SUBTITLES", case_study);

      let deals_tools = data.data.results.find(
        (element) => element.section == "Deals & Tool"
      );
      commit("SET_DEALS_TOOLS_TITLES_SUBTITLES", deals_tools);

      let ugc_creator = data.data.results.find(
        (element) => element.section == "UGC Creator"
      );
      commit("SET_UGC_CREATORS_TITLES_SUBTITLES", ugc_creator);

      let our_process = data.data.results.find(
        (element) => element.section == "Our Process"
      );
      commit("SET_OUR_PROCESS_TITLES_SUBTITLES", our_process);

      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_ADVERTISEMENTS({ state, commit }, addedFilters) {
    let filters = {};
    if (addedFilters) filters = { ...addedFilters };
    if (state.filters) {
      Object.keys(state.filters).forEach((key) => {
        if (state.filters[key]) {
          filters[key] = state.filters[key];
        }
      });
    }
    if (filters['platform']) {
      if (filters['platform'] == 'tiktok') {
        commit("SET_ADVERTISEMENTS", null);
        return { success: true, data: [] };
      }
    }
    let take = state.adsPerPage / 2;
    let skip = (state.page - 1) * take;

    if (!(state.totalAdvertisements == 0 && state.totalTiktoks == 0)) {
      if (skip >= state.totalTiktoks) {
        skip = skip * 2 - state.totalTiktoks;
        take = 2 * take;
      } else if (state.totalTiktoks - skip < take) {
        take = take + take - state.totalTiktoks + skip;
      }
    }

    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/advertisements`,
        headers: {
          Authorization: state.token,
        },
        params: {
          take,
          skip,
          visible: true,
          role: state.role,
          user_id: state.user.id,
          ...filters,
        },
      });
      commit("SET_ADVERTISEMENTS", data.data.results);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_TOTAL_DISCOVER({ state, commit }, addedFilters) {
    let filters = {};
    if (addedFilters) filters = { ...addedFilters };
    if (state.filters) {
      Object.keys(state.filters).forEach((key) => {
        if (state.filters[key]) {
          filters[key] = state.filters[key];
        }
      });
    }
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/total-discover`,
        headers: {
          Authorization: state.token,
        },
        params: {
          visible: true,
          role: state.role,
          user_id: state.user.id,
          ...filters,
        },
      });
      console.log('total_adadad', data.data)
      commit("SET_TOTAL_DISCOVER", data.data.total);
      commit("SET_TOTAL_ADVERTISEMENTS", data.data.totalAdvertisement);
      commit("SET_TOTAL_TIKTOKS", data.data.totalTiktok);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_ADS_TOTAL({ state, commit }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/advertisements/total`,
        headers: {
          Authorization: state.token,
        },
      });
      commit("SET_ADS_TOTAL", data.data.total);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  GET_AD_FROM_ARRAY({ state, commit }, id) {
    let prevItem = null;
    let currentIndex = null;
    state.advertisements.forEach((item, index) => {
      if (item.id === id) {
        commit("SET_CURRENT_AD", item);
        commit("SET_PREV_ID_AD", prevItem.id);
        currentIndex = index;
      }
      if (currentIndex + 1 === index) {
        commit("SET_NEXT_ID_AD", item.id);
      }
      prevItem = item;
    });
  },
  async GET_AD_BY_ID({ state, dispatch }, id) {
    if (state.advertisements) {
      dispatch("GET_AD_FROM_ARRAY", id);
    } else {
      dispatch("GET_AD_FROM_API");
    }
  },
  async GET_USER({ state, commit, dispatch }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/user`,
        headers: {
          Authorization: state.token,
        },
      });
      Cookies.set("adbox_auth_status", data.data.subscription_status, {
        domain: process.env.VUE_APP_ADBOX_DOMAIN,
        expires: new Date(data.expires_in),
      });

      Cookies.set("adbox_auth_first_signin", data.data.first_signin, {
        domain: process.env.VUE_APP_ADBOX_DOMAIN,
        expires: new Date(data.expires_in),
      });
      if (
        data.data.user_collections_collection &&
        data.data.user_collections_collection > 0
      ) {
        const collectionMonths = data.data.user_collections_collection.map(
          (element) => {
            return (element = {
              value: JSON.parse(
                JSON.stringify(element.collection.collection_date)
              ),
              label: moment(element.collection.collection_date).format(
                "MMMM YYYY"
              ),
            });
          }
        );
        data.data.collectionMonths = collectionMonths;
      }
      commit("SET_USER", data.data);
      commit("SET_STATUS", data.data.subscription_status);
      commit("SET_FIRST_SIGNIN", data.data.first_signin);

      return { success: true, data: data.data };
    } catch (error) {
      dispatch("SIGN_OUT");
      return { success: false, data: error.response.data.data };
    }
  },
  async GET_SUBSCRIPTION_BY_USER({ state, commit }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/users/subscription`,
        headers: {
          Authorization: state.token,
        },
        params: {
          payments: true,
          subscription_id: state.user.subscription_id,
        },
      });
      commit("SET_SUBSCRIPTION", data.data);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response.data.data };
    }
  },
  async GET_TRANSACTION_BY_USER({ state, commit }) {
    try {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/users/transaction`,
        headers: {
          Authorization: state.token,
        },
        params: {
          payments: true,
          checkout_id: state.user.checkout_id,
        },
      });
      commit("SET_TRANSACTION", data.data);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response.data.data };
    }
  },
  async UPDATE_USER({ state }) {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/user`,
        headers: {
          Authorization: state.token,
        },
        data: state.user,
      });
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
  async GET_MEMBERSHIPS({ commit }) {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/memberships`,
      });
      commit("SET_MEMBERSHIPS", response.data.memberships);
      return { success: true, data: response.data.memberships };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_VERBAL_HOOKS({ state, commit }) {
    try {
      const response = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/verbal-hooks`,
        data: {
          skip: 30 * (state.pageVerbalHooks - 1),
          take: 30,
        },
      });
      commit("SET_VERBAL_HOOKS", response.data.verbal_hooks);
      commit("SET_TOTAL_VERBAL_HOOKS", response.data.total);
      return { success: true, data: response.data.verbal_hooks };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async GET_TOTAL_USERS({ commit, state }) {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/users/total`,
        headers: {
          Authorization: state.token,
        },
      });
      commit("SET_TOTAL_USERS", response.data.total);
      return { success: true, data: response.data.total };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },

  async GET_UGC_CREATORS({ state, commit }) {
    try {
      let filters = [];
      if (state.filters_ugcCreators) {
        Object.keys(state.filters_ugcCreators).forEach((key) => {
          if (state.filters_ugcCreators[key]) {
            filters[key] = state.filters_ugcCreators[key];
          }
        });
      }

      let params = {
        page: state.pageUgcCreators,
        size: 30,
        user_id: state.user.id,
        ...filters,
      };

      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/ugc-creators`,
        params,
      });
      if (!response.data.ugc_creators.length) {
        let params = {
          page: 1,
          size: 30,
          ...filters,
        };

        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/ugc-creators`,
          params,
        });
        commit("SET_UGC_CREATORS", response.data.ugc_creators);
        commit("SET_TOTAL_UGC_CREATORS", response.data.total);
        return { success: true, data: response.data.ugc_creators };
      }

      commit("SET_UGC_CREATORS", response.data.ugc_creators);
      commit("SET_TOTAL_UGC_CREATORS", response.data.total);
      return { success: true, data: response.data.ugc_creators };
    } catch (error) {
      return { success: false, data: error.response };
    }
  },
  async BUY_MEMBERSHIP({ state, dispatch }, { plan_id }) {
    const referral = window.Rewardful && window.Rewardful.referral;
    window.Paddle.Checkout.open({
      product: plan_id,
      passthrough: JSON.stringify({ rewardful: { referral: referral } }),
      type: state.user.type,
      email: state.user.email,
      allowQuantity: false,
      disableLogout: true,
      successCallback: (data) => {
        Cookies.set(`pending_upgrade_${state.user.id}`, "true", { expires: 1 });
        dispatch("PADDLE_CHECKOUT_SUCCESS", data);
      },
    });
  },
  async PADDLE_CHECKOUT_SUCCESS({ commit, dispatch }, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          currency: data.checkout.prices.customer.currency,
          transaction_id: data.checkout.id,
          value: Number(data.checkout.prices.customer.total),
          coupon: data.checkout.coupon.coupon_code,
          tax: Number(data.checkout.prices.customer.total_tax),
          items: [
            {
              item_id: data.product.id.toString(),
              item_name: data.product.name,
              affiliation: "Adbox",
              index: 1,
              item_brand: "Adbox Membership",
              price: Number(data.checkout.prices.customer.total),
              quantity: data.product.quantity,
            },
          ],
        },
      });
    } catch (error) {
      console.log("PADDLE_CHECKOUT_SUCCESS ERROR:", error);
    }
    commit("SET_OURPLANS_ACTIVE", false);
    router.push("/thank-you");
    await sleep(5000);
    dispatch("GENERATE_TOKEN_BY_USER_ID");
  },
  async GENERATE_TOKEN_BY_USER_ID({ state, dispatch }) {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/generate-token-by-user-id`,
        headers: {
          Authorization: state.token,
        },
        data: {
          id: state.user.id,
        },
      });
      dispatch("AUTHENTICATE_BY_NEW_SUBSCRIPTION", data.data);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
  async UPGRADE_SUBSCRIPTION({ state, dispatch }) {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/subscription/upgrade`,
        headers: {
          Authorization: state.token,
        },
        data: {
          subscription_id: state.user.subscription_id,
        },
      });
      dispatch("AUTHENTICATE_BY_UPGRADE", data.data);
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
  async CHANGE_PASSWORD({ state }, { old_password, new_password }) {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/change-password`,
        headers: {
          Authorization: state.token,
        },
        data: {
          old_password,
          new_password,
        },
      });
      return { success: true, data: data.data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
  AUTHENTICATE({ commit }) {
    const token = Cookies.get("adbox_auth_token");
    if (token) {
      commit("SET_TOKEN", token);
      commit("SET_ROLE", Cookies.get("adbox_auth_role"));
      commit("SET_STATUS", Cookies.get("adbox_auth_status"));
      commit("SET_FIRST_SIGNIN", Cookies.get("adbox_auth_first_signin"));
    }
  },
  AUTHENTICATE_BY_UPGRADE(_, data) {
    Cookies.set("adbox_auth_token", data.access_token, {
      domain: process.env.VUE_APP_ADBOX_DOMAIN,
      expires: new Date(data.expires_in),
    });
    Cookies.set("adbox_auth_role", data.role, {
      domain: process.env.VUE_APP_ADBOX_DOMAIN,
      expires: new Date(data.expires_in),
    });
    window.location.href = process.env.VUE_APP_ADBOX_APP_FRONT_URL;
  },
  AUTHENTICATE_BY_NEW_SUBSCRIPTION(_, data) {
    Cookies.set("adbox_auth_token", data.access_token, {
      domain: process.env.VUE_APP_ADBOX_DOMAIN,
      expires: new Date(data.expires_in),
    });
    Cookies.set("adbox_auth_role", data.user.role, {
      domain: process.env.VUE_APP_ADBOX_DOMAIN,
      expires: new Date(data.expires_in),
    });
    window.location.href = process.env.VUE_APP_ADBOX_APP_FRONT_URL;
  },
  async SIGN_OUT({ state }) {
    if (state.user.first_signin) {
      try {
        await axios({
          method: "PUT",
          url: `${process.env.VUE_APP_ADBOX_API_V2_URL}/user`,
          headers: {
            Authorization: state.token,
          },
          data: {
            user_id: state.user.id,
          },
        });
      } catch (error) {
        return { success: false, data: error.response.data };
      }
    }
    Cookies.remove("adbox_auth_token", {
      domain: process.env.VUE_APP_ADBOX_DOMAIN,
    });
    Cookies.remove("adbox_auth_role", {
      domain: process.env.VUE_APP_ADBOX_DOMAIN,
    });
    window.location.href = process.env.VUE_APP_ADBOX_FRONT_URL;
  },
  async ADD_FAVORITE_AD({ state, commit }, { user_id, advertisement }) {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/favorites`,
        headers: {
          Authorization: state.token,
        },
        data: {
          userId: user_id,
          advertisementId: advertisement.id,
        },
      });
      commit("ADD_AD_TO_FAVORITES", advertisement);
      return { success: true, data: data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
  async REMOVE_FAVORITE_ADD({ state, commit }, { user_id, advertisement_id }) {
    try {
      const { data } = await axios({
        method: "DELETE",
        url: `${process.env.VUE_APP_ADBOX_API_URL}/favorites/${advertisement_id}/${user_id}`,
        headers: {
          Authorization: state.token,
        },
      });
      commit("REMOVE_AD_TO_FAVORITES", advertisement_id);
      return { success: true, data: data };
    } catch (error) {
      return { success: false, data: error.response.data };
    }
  },
};
